import { gql } from "@apollo/client";

// The fields of one answer that the review form shows and edits. The shared
// fields sit on the interface, so the backend's limit of 55 fields per level
// (GRAPHQL_QUERY_ITEMS_PER_LEVEL_LIMIT) is not reached: GetAssessmentAnswers
// is not on its allow list.
export default gql`
  fragment AssessmentFormAnswer on AssessmentAnswerInterface {
    id
    questionId
    comment
    isLocked
    ... on RangeAssessmentAnswerNode {
      integerAnswer
    }
    ... on IndividualGoalAssessmentAnswerNode {
      integerAnswer
    }
    ... on OverallGoalAssessmentAnswerNode {
      integerAnswer
    }
    ... on IndividualRecognitionCoreValueAssessmentAnswerNode {
      integerAnswer
    }
    ... on OverallRecognitionCoreValueAssessmentAnswerNode {
      integerAnswer
    }
    ... on ResponsibilityAssessmentAnswerNode {
      integerAnswer
    }
    ... on TalentIndicatorAssessmentAnswerNode {
      integerAnswer
    }
    ... on CompetencyAssessmentAnswerNode {
      integerAnswer
    }
    ... on CompetencyCriteriaAssessmentAnswerNode {
      integerAnswer
    }
    ... on NpsAssessmentAnswerNode {
      integerAnswer
    }
    ... on MultiChoiceAssessmentAnswerNode {
      choices
    }
    ... on TextAssessmentAnswerNode {
      textAnswer
    }
  }
`;
